/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto2 } from '../../models/faq-dto-2';
import { FaqShowResponse } from '../../models/faq-show-response';

export interface PatchFaqUpdate$Params {
  name: string;
      body: FaqDto2
}

export function patchFaqUpdate(http: HttpClient, rootUrl: string, params: PatchFaqUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchFaqUpdate.PATH, 'patch');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqShowResponse>;
    })
  );
}

patchFaqUpdate.PATH = '/v1/faq/{name}';
